import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Andrew Laws
 * id 70793340-E8F2-43A0-8AB1-0DAB70CC8B9A
 * name magazine-rifle
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/magazine-rifle.svg
 * tags
 */
export const MagazineRifleIcon = createSvgIcon(<><path d="M7 1V3H8V13L5 19L14 23L18 13V3H19V1M10 3H16V5H11.88V13.45L9.6 18.14L8 17.5L10 13.5Z" /></>, 'MagazineRifleIcon');
export default MagazineRifleIcon